module.exports = __webpack_public_path__ + "img/logo_mark_white_gold.37f846da.svg";